import { LibraryCollectionItem, LibraryFolder } from '@go-modules/interfaces/library/library-collection';

export const NodeType = {
	Folder: 'folder',
	Item: 'item'
} as const;

export type NodeKind = typeof NodeType[keyof typeof NodeType];

type DataFor<T extends NodeKind> =
	T extends typeof NodeType.Folder ? LibraryFolder : LibraryCollectionItem;

export class LibraryTreeNode<T extends NodeKind = NodeKind> {
	constructor (
		public data: DataFor<T>,
		public readonly type: T,
		public level: number = 0,
		public expandable: boolean = false,
		public isLoading: boolean = false,
		public checked: boolean = false
	) {}

	public isFolder (): this is LibraryTreeNode<typeof NodeType.Folder> {
		return this.type === NodeType.Folder;
	}
	public isItem (): this is LibraryTreeNode<typeof NodeType.Item> {
		return this.type === NodeType.Item;
	}

	public get key (): string {
		if (this.isFolder()) return `${this.type}_${this.data.id}`;
		if (this.isItem())   return `${this.type}_${this.data.hash}`;
		throw new Error('Unknown node type');
	}

	// Pseudo items have null ids
	public get entityId (): number | null {
		return this.data.id;
	}
}
